import { render } from "./_MissionVision.vue?vue&type=template&id=64bce3a4&scoped=true&lang=en"
import script from "./_MissionVision.vue?vue&type=script&lang=js"
export * from "./_MissionVision.vue?vue&type=script&lang=js"

import "./_MissionVision.vue?vue&type=style&index=0&id=64bce3a4&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bce3a4"]])

export default __exports__